import clsx from "clsx";
import { ReactNode } from "react";

export const ButtonGroupFlexBox = ({
  className,
  primaryButton,
  secondaryButton,
  forceButtonWidth = false,
}: {
  className?: string;
  primaryButton: ReactNode;
  secondaryButton: ReactNode;
  forceButtonWidth?: boolean;
}) => (
  <div
    className={clsx(
      "mt-6 flex flex-col gap-4 sm:col-span-2 sm:mt-10 sm:flex-row-reverse sm:justify-between",
      forceButtonWidth &&
        "[&>a]:w-full sm:[&>a]:w-fit [&>button]:w-full sm:[&>button]:w-fit [&>div>a]:w-full sm:[&>div>a]:w-fit [&>div>button]:w-full sm:[&>div>button]:w-fit",
      className,
    )}
  >
    {primaryButton}
    {secondaryButton}
  </div>
);
